import './List.css';
export var listCSS = '_16276mt0-3-12-1';
export var listItemCSS = '_16276mt1-3-12-1';